<button
  type="button"
  [class]="triggerClass()"
  [matMenuTriggerFor]="menu"
  (click)="$event.stopPropagation()"
  (keydown.enter)="$event.stopPropagation()"
  (keydown.space)="$event.stopPropagation()"
  [attr.aria-label]="'customers.actions_aria' | transloco"
>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu">
  <button mat-menu-item type="button" (click)="switchContext.emit(customer())">
    <mat-icon>swap_horiz</mat-icon>
    <span>{{ 'customers.switch_to_customer' | transloco }}</span>
  </button>
  <button mat-menu-item type="button" (click)="openDocuments.emit(customer())">
    <mat-icon>description</mat-icon>
    <span>{{ 'actions.manage_documents' | transloco }}</span>
  </button>
  <span
    [matTooltip]="'customers.reinvite_disabled_tooltip' | transloco"
    [matTooltipDisabled]="!isAccepted()"
  >
    <button
      mat-menu-item
      type="button"
      [disabled]="!canReinvite()"
      (click)="reinvite.emit(customer())"
    >
      <mat-icon>forward_to_inbox</mat-icon>
      <span>{{ 'customers.resend_invitation' | transloco }}</span>
    </button>
  </span>
</mat-menu>
